import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export const sortGws = (gws) => [...gws].sort((a, b) => a.week_number - b.week_number);

// The week being played: first gameweek whose end date (or deadline) hasn't passed yet.
export const pickCurrentGw = (gws) => {
  const sorted = sortGws(gws);
  const now = new Date();
  const current = sorted.find((g) => {
    const end = g.end_date || g.deadline;
    return end && new Date(end) >= now;
  });
  return current || sorted[sorted.length - 1] || null;
};

export const GameweekSelect = ({ gameweeks, value, onChange, testId = "gw-select" }) => {
  const current = pickCurrentGw(gameweeks);
  return (
    <Select value={value?.id || ""} onValueChange={(v) => onChange(gameweeks.find((g) => g.id === v))}>
      <SelectTrigger data-testid={testId} className="w-[220px] bg-[#0D2038] border-[#1F3A5C] text-white font-medium">
        <SelectValue placeholder="Select week" />
      </SelectTrigger>
      <SelectContent className="bg-[#0D2038] border-[#1F3A5C] text-white max-h-72">
        {sortGws(gameweeks).map((g) => (
          <SelectItem key={g.id} value={g.id} data-testid={`${testId}-option-${g.week_number}`}>
            Gameweek {g.week_number}{current?.id === g.id ? " · current" : ""}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};
